.icon {
  display: inline-block;
  color: inherit;
  fill: currentColor;
}

// The sprite generator strips every fill="..." from a source SVG, fill="none" included, so an
// outline icon's empty fill has to come from here.
.icon.outline {
  fill: none;
}
